import { GrfqLeg } from '#/unified-rfqs/entities/grfq/domain';
import {
  getEffectiveContractSize,
  getEffectiveMinContractIncrement,
  getProduct,
} from '#/products/domain';
import {
  isValidDecimal,
  parseFormattedFloat,
  unformatDecimal,
} from '@paradigm/utils/formatDecimal';
import { formatProductQty } from '#/unified-rfqs/ui/decimal-format';
import { isDatedInstrument } from '#/unified-rfqs/ui/rfqs/legs-functions';

export default function quantityView(
  value: string,
  [firstLeg]: readonly GrfqLeg[],
) {
  const product = getProduct(firstLeg!.product_code);
  const { quantityPrecision } = product;
  const unformattedQty = unformatDecimal(value);

  return {
    value,
    precision: quantityPrecision,
    error: validateQuantityErrors(
      unformattedQty,
      product,
      isDatedInstrument(firstLeg!.instrument),
    ),
  };
}

export const validateQuantityErrors = (
  quantity: string,
  product: ReturnType<typeof getProduct>,
  isDated: boolean,
): string | undefined => {
  if (quantity === '' || !isValidDecimal(quantity)) return;
  const minContractIncrement = getEffectiveMinContractIncrement(
    product,
    isDated,
  );

  const formattedNormalizedValue = formatProductQty(quantity, product.code);
  const floatValue = parseFormattedFloat(formattedNormalizedValue);

  const minIncrement =
    minContractIncrement * getEffectiveContractSize(product, isDated);
  if (!Number.isInteger(minIncrement)) return;

  const isValidMinIncrement = floatValue % minIncrement === 0;
  if (isValidMinIncrement) return;

  return `${formattedNormalizedValue} is not a valid increment of ${minIncrement}`;
};
